module.exports = __webpack_public_path__ + "static/media/icon-close.232ef379.svg";